import React from 'react';
import Link from 'next/link';
import { useSelector } from 'react-redux';
import Navbar from '../components/Navbars/AppNavbar.js';
import Footer from '../components/Footers/Footer.js';
import FooterSM from '../components/Footers/FooterSmall.js';
import ResourcesContainer from '../components/Resources/index.js';
import Head from 'next/head';
import { NextSeo } from 'next-seo';
import Storyblok from '../lib/storyblok';

export default function Resources(props) {
  const userDataRedux = useSelector((state) => state.authReducer.userData);
  const SEO = {
    title: 'MusicArt | Resources',
    // description:'We will contact you back vi email',
    canonical: 'https://musicart.io/resources',
  };

  console.log('pppppppp', props);
  return (
    <>
      <Head>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, shrink-to-fit=no"
        />
        <link rel="canonical" href="https://musicart.io/resources" />
      </Head>

      {props.allcontent && props.allcontent.seo_metatags && (
        <>
          <NextSeo
            title={`${props.allcontent.seo_metatags.title}`}
            description={props.allcontent.seo_metatags.description}
            og_description={props.allcontent.seo_metatags.og_description}
            og_image={props.allcontent.seo_metatags.og_image}
            og_title={props.allcontent.seo_metatags.og_title}
            twitter_description={
              props.allcontent.seo_metatags.twitter_description
            }
            twitter_image={props.allcontent.seo_metatags.twitter_image}
            twitter_title={props.allcontent.seo_metatags.twitter_title}
          />
        </>
      )}
      <Navbar transparent />
      <ResourcesContainer allcontent={props.allcontent && props.allcontent} />
      <Footer />
      <FooterSM />
    </>
  );
}

export async function getStaticProps(context) {
  // the storyblok params
  let params = {
    version: 'draft', // or 'published' / ' draft
  };

  // checks if Next.js is in preview mode
  if (context.preview) {
    // loads the draft version
    params.version = 'draft';
    // appends the cache version to get the latest content
    params.cv = Date.now();
  }

  let story = await Storyblok.get(`cdn/stories/resources`, params);
  let allcontent = story.data.story.content;
  // return the story from Storyblok and whether preview mode is active
  return {
    props: {
      allcontent: allcontent,
      preview: context.preview || false,
    },
    revalidate: 10,
  };
}
